import React from "react";
import StyledTextarea from "components/Textarea/styled/StyledTextarea";

const Textarea = ({ input, meta,  ...props }) => {
	return (<StyledTextarea  {...input} {...meta} {...props} />)
};

export default Textarea;
